
import Vue from "vue";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
export default Vue.extend({
	data(){
		return {
			start: "",
			end: ""
		};
	},
	props: {
		value: {
			type: String,
			required: true
		},
		label: String
	},
	watch: {
		start(){
			this.setValues();
		},
		end(){
			this.setValues();
		}
	},
	methods: {
		setStart(l:string){
			console.log(l);
			this.start = l;
		},
		setEnd(l:string){
			this.end = l;
		},
		setValues(){
			this.$emit("input", JSON.stringify({start: this.start, end: this.end}));
		}
	},
	created(){
		this.setValues();
	},
	components: {
		AppLedgerAccountAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.reportengine",
	}
});
